import { hasProperty } from '@direct-frontend/stdlib';

const SCROLLABLE_OVERFLOW_REGEXP = /(auto|scroll|overlay)/;

function isScrollableElement(element: HTMLElement): boolean {
    const { overflowY, overflow } = window.getComputedStyle(element);
    const hasScrollableOverflow = SCROLLABLE_OVERFLOW_REGEXP.test(`${overflowY}${overflow}`);

    return hasScrollableOverflow && element.scrollHeight > element.clientHeight;
}

function findScrollableParent(element: HTMLElement): HTMLElement | null {
    let parent = element.parentElement;

    while (parent) {
        if (isScrollableElement(parent)) {
            return parent;
        }

        parent = parent.parentElement;
    }

    return null;
}

/**
 * Скроллит до элемента:
 * - если найден ближайший скролл-контейнер, скроллит контейнер;
 * - иначе использует стандартный scrollIntoView.
 */
export function scrollToElement(element: Element) {
    if (!(element instanceof HTMLElement)) {
        return;
    }

    const scrollContainer = findScrollableParent(element);

    if (!scrollContainer) {
        if (hasProperty(element, 'scrollIntoView')) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        return;
    }

    const elementRect = element.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();

    const relativeTop = elementRect.top - containerRect.top + scrollContainer.scrollTop;
    const targetScroll = relativeTop - scrollContainer.clientHeight / 2 + elementRect.height / 2;

    requestAnimationFrame(() => {
        // Скролл не работает у document.body, в таком случае сколлим на window.
        // Однако, у window нет getBoundingClientRect, поэтому подменяем только здесь.
        const scroller = scrollContainer === document.body ? window : scrollContainer;
        if (hasProperty(scroller, 'scrollTo')) {
            scroller.scrollTo({
                top: Math.max(0, targetScroll),
                behavior: 'smooth',
            });
        }
    });
}
